import { SellerOfferStatus } from 'remarketing-angular-library/enums/enums';
import { BuyFee } from 'remarketing-angular-library/interfaces/buy-fee';

export enum PurchaseType {
  BidPlaced    = 'BID_PLACED',
  BuyNowPlaced = 'BUY_NOW_PLACED',
  OfferAdded   = 'OFFER_ADDED',
  OfferUpdated = 'OFFER_UPDATED',
}

export enum AuctionItemStatus {
  AcceptingOffers     = 'ACCEPTING_OFFERS',
  PendingSellerAction = 'PENDING_SELLER_ACTION',
  PendingBuyerAction  = 'PENDING_BUYER_ACTION',
  OfferDeclined       = 'OFFER_DECLINED',
  AcceptingBids       = 'ACCEPTING_BIDS',
  BiddingInProgress   = 'BIDDING_IN_PROGRESS',
  Leading             = 'LEADING',
  OutBid              = 'OUTBID',
  NotSold             = 'NOT_SOLD',
  OnHold              = 'ON_HOLD',
  VehicleRemoved      = 'VEHICLE_REMOVED',
  VehicleExpired      = 'VEHICLE_EXPIRED',
  Sold                = 'SOLD',
  Won                 = 'WON',
  RankOnly            = 'RANK_ONLY',
  None                = 'NONE'
}

export type BuyerAuctionItemStatus =
  AuctionItemStatus.AcceptingOffers |
  AuctionItemStatus.PendingSellerAction |
  AuctionItemStatus.PendingBuyerAction |
  AuctionItemStatus.Won

export type SellerAuctionItemStatus =
  AuctionItemStatus.AcceptingOffers |
  AuctionItemStatus.PendingSellerAction |
  AuctionItemStatus.PendingBuyerAction |
  AuctionItemStatus.Sold

export enum PurchaseStatus  {
  AcceptingOffers = 'Accepting Offers',
  OfferSubmitted  = 'Offer Submitted',
  OfferAccepted   = 'Offer Accepted',
  OfferWithdrawn  = 'Offer Withdrawn',
  OfferCountered  = 'Offer Countered',
  OfferRevived    = 'Offer Revived',
  OfferCancelled  = 'Offer Cancelled',
  OfferDeclined   = 'Offer Declined',
  Outbid          = 'Outbid',
  Sold            = 'Sold',
  Won             = 'Won'
}

export type BuyerPurchaseStatus =
  PurchaseStatus.AcceptingOffers |
  PurchaseStatus.OfferSubmitted |
  PurchaseStatus.OfferAccepted |
  PurchaseStatus.OfferWithdrawn |
  PurchaseStatus.OfferCountered |
  PurchaseStatus.OfferRevived |
  PurchaseStatus.OfferCancelled |
  PurchaseStatus.OfferDeclined |
  PurchaseStatus.Won

export type SellerPurchaseStatus =
  PurchaseStatus.AcceptingOffers |
  PurchaseStatus.OfferSubmitted |
  PurchaseStatus.OfferAccepted |
  PurchaseStatus.OfferWithdrawn |
  PurchaseStatus.OfferCountered |
  PurchaseStatus.OfferRevived |
  PurchaseStatus.OfferCancelled |
  PurchaseStatus.OfferDeclined |
  PurchaseStatus.Sold

export type AuctionItemBidPlaced = {
  purchaseType: PurchaseType.BidPlaced;

  auctionItemUuid: string;
  bidAmount: number;
  leadBidderOeUuid: string;
  leadBidderLeadBuyerOeUuid: string;
  leadBidderName: string;
  enableBuyNow: boolean;
  outBidderOeUuid: string;
  buyerOeUuid: string;

  buyerAuctionItemStatus: BuyerAuctionItemStatus,
  buyerPurchaseStatus: BuyerPurchaseStatus,

  outbidAuctionItemStatus: string;
  outbidPurchaseStatus: string;

  auctionItemStatus: string;
  purchaseStatus: string;
}


export type AuctionItemBuyNowPlaced = {
  purchaseType: PurchaseType.BuyNowPlaced;

  auctionItemUuid: string;
  buyerOeUuid: string;
  enableBuyNow: boolean;
  enableBid: boolean;
  enableViewOffer: boolean;

  buyerAuctionItemStatus: BuyerAuctionItemStatus,
  buyerPurchaseStatus: BuyerPurchaseStatus,

  auctionItemStatus: string;
  purchaseStatus: string;
  buyFee: BuyFee;
}


export type AuctionItemOfferAdded = {
  purchaseType: PurchaseType.OfferAdded;

  offerUuid: string;
  offerStatus: SellerOfferStatus;
  sellerOeUuid: string;
  auctionItemUuid: string;
  buyerOeUuid: string;
  leadBuyerOeUuid: string;
  amount: number;

  buyerAuctionItemStatus: BuyerAuctionItemStatus,
  buyerPurchaseStatus: BuyerPurchaseStatus,

  sellerAuctionItemStatus: SellerAuctionItemStatus,
  sellerPurchaseStatus: SellerPurchaseStatus
}


export type AuctionItemOfferUpdated = {
  purchaseType: PurchaseType.OfferUpdated;

  offerUuid: string;
  sellerOeUuid: string;
  auctionItemUuid: string;
  inventoryItemUuid: string;
  buyerOeUuid: string;
  leadBuyerOeUuid: string;
  amount: number;

  auctionItemStatus: string;
  purchaseStatus: string;
  enableViewOffer: boolean;
  enableBuyNow: boolean;
  enableBid: boolean;

  buyerAuctionItemStatus: BuyerAuctionItemStatus,
  buyerPurchaseStatus: BuyerPurchaseStatus,

  sellerAuctionItemStatus: SellerAuctionItemStatus,
  sellerPurchaseStatus: SellerPurchaseStatus;
  buyFee: BuyFee;
}
